"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  hu: {
    orders: {
      actions: {
        addNewOrder: 'új megrendelés hozzáadása',
        all: 'összes megrendelés'
      },
      listPage: {
        title: 'megrendelések',
        table: {
          filter: {
            number: 'szám'
          },
          columns: {
            contact: 'kapcsolat',
            dateOfOrder: 'megrendelés dátuma',
            number: 'szám',
            offer: 'ajánlat',
            opportunity: 'lehetõség',
            owner: 'tulajdonos',
            state: 'ország',
            total: 'összesen',
            totalUserCurrency: 'összesen {currency} -ban'
          }
        }
      },
      order: {
        newEntity: 'új megrendelés',
        contact: {
          label: 'kapcsolat',
          helperText: '',
          helperTextPreview: ''
        },
        commissionTotal: {
          label: 'teljes jutalék',
          helperText: '',
          helperTextPreview: ''
        },
        currency: {
          label: 'pénznem',
          helperText: '',
          helperTextPreview: ''
        },
        dateOfOrder: {
          label: 'megrendelés idõpontja',
          helperText: '',
          helperTextPreview: ''
        },
        number: {
          label: 'szám',
          helperText: 'automatikusan generált szám megadásához hagyd a mezõt üresen.',
          helperTextPreview: ''
        },
        offer: {
          label: 'ajánlat',
          helperText: '',
          helperTextPreview: ''
        },
        opportunity: {
          label: 'lehetõség',
          helperText: '',
          helperTextPreview: ''
        },
        owner: {
          label: 'tulajdonos',
          helperText: '',
          helperTextPreview: ''
        },
        salesMargin: {
          label: 'üzleti árrés',
          helperText: '',
          helperTextPreview: ''
        },
        subjects: {
          title: 'alanyok',
          discount: {
            label: 'engedmény',
            helperText: '',
            helperTextPreview: ''
          },
          commission: {
            label: 'jutalék',
            helperText: '',
            helperTextPreview: ''
          },
          list: {
            package: 'csomag nagysága'
          },
          listPrice: {
            label: 'listaár',
            helperText: '',
            helperTextPreview: ''
          },
          price: {
            label: 'ár',
            helperText: '',
            helperTextPreview: ''
          },
          product: {
            label: 'Product',
            helperText: '',
            helperTextPreview: ''
          },
          quantity: {
            label: 'mennyiség',
            helperText: '',
            helperTextPreview: ''
          },
          salesMargin: {
            label: 'üzleti jutalék',
            helperText: '',
            helperTextPreview: ''
          },
          subjectTotal: {
            label: 'összes alany',
            helperText: '',
            helperTextPreview: ''
          },
          unit: {
            label: 'egység',
            helperText: '',
            helperTextPreview: ''
          }
        },
        total: {
          label: 'összesen',
          helperText: '',
          helperTextPreview: ''
        },
        numberOfSubjects: '{number, plural, =0 {no items} egy {1 item} másik {{number} items}}'
      },
      myOrdersScoringBlog: {
        title: 'megrendeléseim'
      },
      ordersList: 'megrendelések'
    }
  }
};
var _default = messages;
exports.default = _default;